function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
const variantComponentMap = {
  "page-title": "h1",
  "title-primary": "h2",
  "title-secondary": "h3"
};
const styles = {
  base: "m-0 text-primary",
  weights: {
    regular: "font-normal",
    semibold: "font-semibold"
  },
  alignments: {
    start: "text-start",
    end: "text-end",
    center: "text-center",
    justify: "text-justify"
  },
  variants: {
    "page-title": "text-4xl font-semibold",
    "title-primary": "bolt-font-heading-s-accent",
    "title-secondary": "bolt-font-body-l-accent",
    "body-primary": "bolt-font-body-m-regular",
    "body-secondary": "bolt-font-body-s-regular",
    "label-primary": "bolt-font-body-s-regular",
    "label-secondary": "bolt-font-body-xs-regular",
    "caption-primary": "bolt-font-body-s-regular",
    "caption-secondary": "bolt-font-body-xs-regular"
  },
  lineClamp: {
    1: "line-clamp-1",
    2: "line-clamp-2",
    3: "line-clamp-3",
    4: "line-clamp-4",
    none: "line-clamp-none"
  }
};
export function Typography(_ref) {
  let {
    align,
    as,
    children,
    color,
    fontSize,
    fontWeight,
    inline,
    lines,
    variant = "body-m-regular",
    noWrap = false,
    inlineStyle,
    paddingTop,
    paddingBottom
  } = _ref;
  const Component = as ?? variantComponentMap[variant] ?? "span";
  const inlineElementStyles = _objectSpread(_objectSpread(_objectSpread({}, paddingTop && {
    paddingTop: getRemFomSpacingSize(paddingTop)
  }), paddingBottom && {
    paddingBottom: getRemFomSpacingSize(paddingBottom)
  }), inlineStyle);
  return /*#__PURE__*/React.createElement(Component, {
    className: cx(!lines && (inline ? "inline" : "block"),
    // line clamping gets overriden by display: block declaration
    styles.base, styles.variants[variant] ?? `bolt-font-${variant}`, align && styles.alignments[align], fontWeight && styles.weights[fontWeight], color && `text-${color}`,
    // text color classes are safelisted in tailwind.config.js
    fontSize, noWrap && "whitespace-nowrap overflow-hidden text-ellipsis", lines && styles.lineClamp[lines]),
    style: inlineElementStyles
  }, children);
}
function getRemFomSpacingSize(spacingValue) {
  return `${spacingValue / 4}rem`;
}